<div class="container-fluid">
  <div class="row">
    <div class="col-md-8">
      <div class="card shadow-sm customers-form-card">
        <div class="card-header">
          <h3 class="card-title">{{ clientsId ? 'Update Client' : 'Create Client' }}</h3>
        </div>
        <div class="card-body">
        <customers-form [readonlyCustomerForm]="readonly" [customer]="customer" #customersForm
            [additionalData]="{ ranking: rankingValue, code: code }"
            [skipNavigationOnCreate]="isCreating"
            (codeRequired)="onCodeRequired($event)"
            (saveRequested)="onSaveRequested()"
            (onSavedData)="onCustomerSaved($event)" />
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <ranking-bar [readonlyRankingBar]="true" [ranking]="customer?.ranking" [customer]="customer"
        (rankingChange)="updateRanking($event)" />
      <customers-client-code [readonlyClientCode]="readonly" [customer]="customer"
        [hasError]="codeHasError"
        (codeChange)="updateClientCode($event)" />
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <attachments-panel [readonlyAttachmentsPanel]="readonly" [customer]="customer" />
    </div>
    <div class="col-md-6">
      <other-documents [readonlyAttachmentsPanel]="readonly" [customer]="customer" />
    </div>
  </div>
  <div class="row">
    <contacts-customers-form [readonlyContactsCustomer]="readonly" [clientPersons]="clientPersons"
      [isCreating]="isCreating" #contactsForm />
  </div>
  <div class="row mt-4">
    <notes-customers-form [readonlyCustomerNotes]="readonly" [customer]="customerNotes"
      [noteServiceMethod]="customerService" [addNoteMethod]="'createNotes'" [deleteNoteMethod]="'deleteNotes'"
      [sectionAttribute]="'clientsId'" #notesForm />
  </div>
  <!-- <div class="text-center mt-4">
    <button type="button" class="btn btn-success px-4 py-2" (click)="saveAllForms()">
      Save
    </button>
  </div> -->
</div>